import makeStyles from "e100-react-components/lib/styles/makeStyles";

export const useStyles = makeStyles(() => ({
  battery: {
    transform: "translate(0, 0) rotate(90deg)",
    color: "#515B69",
  },
}));
